import { createFileRoute } from '@tanstack/react-router';
import {
  domainTarget,
  legacyDomainSearch,
  redirectToHealthReadiness,
} from '@/components/health-readiness/legacy-redirect';

/**
 * The old Health Check → Domains tab (T-0224, T-0242): lands on the Domains
 * tab at the domain its `?domain=` named, else the first domain.
 */
export const Route = createFileRoute('/engagements/$engagementId/health/domains')({
  validateSearch: legacyDomainSearch,
  beforeLoad: ({ params, search }) => {
    throw redirectToHealthReadiness(params.engagementId, domainTarget(search, { tab: 'domains' }));
  },
});
